import type { Selection } from '../../ThreeDStockContentImageLensTypes';

interface ThreeDStockContentImageLensSelectionOverlayProps {
  selection: Selection;
}

function ThreeDStockContentImageLensSelectionOverlay({
  selection
}: ThreeDStockContentImageLensSelectionOverlayProps) {
  return (
    <div
      className="absolute pointer-events-none rounded-2xl"
      style={{
        left: selection.x,
        top: selection.y,
        width: selection.w,
        height: selection.h,
        boxShadow: '0 0 0 9999px rgba(0,0,0,0.55)'
      }}
    />
  );
}

export default ThreeDStockContentImageLensSelectionOverlay;
